import { Directive, forwardRef, Injectable, Input, NgModule } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';


@Injectable()
export class CustomValidators {

    min(control: AbstractControl, value: number): { [key: string]: boolean } {
        return control.value >= value ? null : {min: true };
    }

    max(control: AbstractControl, value: number): { [key: string]: boolean } {
        return control.value <= value ? null : {max: true };
    }

}

@Directive({
    selector: '[min][formControlName],[min][formControl],[min][ngModel]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => MinValidator),
        multi: true
    }]
})
export class MinValidator implements Validator {

    constructor(private validators: CustomValidators) {
    }

    @Input() min: number;

    validate(control: AbstractControl) {
        return this.validators.min(control, this.min);
    }
}

@Directive({
    selector: '[max][formControlName],[max][formControl],[max][ngModel]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => MaxValidator),
        multi: true
    }]
})
export class MaxValidator implements Validator {

    constructor(private validators: CustomValidators) {
    }

    @Input() max: number;

    validate(control: AbstractControl) {
        return this.validators.max(control, this.max);
    }
}

@NgModule({
    imports: [  ],
    declarations: [ MinValidator,  MaxValidator],
    exports: [ MinValidator, MaxValidator ],
    providers: [ CustomValidators ]
})
export class MinMaxValidatorModule {

}
